module.exports = __webpack_public_path__ + "static/txtling3-300x249-d9bab381d13bf9259e062a73f3710a85.png";